import React from 'react';
import {PricingTable, PricingSlot, PricingDetail} from 'react-pricing-table';

export default function FeesComparision(){

    return(
    <div className='fees-comp'>
    <table>
    <thead>
      <tr>
        <th></th>
        <th>Other Online Tuitions</th>
        <th>Home Tuitions</th>
        <th>TeacherInd</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Progress Tracker</td>
        <td class="cross">✘</td>
        <td class="cross">✘</td>
        <td class="check">✔</td>
      </tr>
      <tr>
        <td>One Student. One Teacher</td>
        <td class="cross">✘</td>
        <td class="check">✔</td>
        <td class="check">✔</td>
      </tr>
      <tr>
        <td>Flexible Timings</td>
        <td class="cross">✘</td>
        <td class="check">✔</td>
        <td class="check">✔</td>
      </tr>
      <tr>
        <td>Custom Unit Exams</td>
        <td class="check">✔</td>
        <td class="cross">✘</td>
        <td class="check">✔</td>
      </tr>
      <tr>
        <td>Growth Sessions</td>
        <td class="cross">✘</td>
        <td class="cross">✘</td>
        <td class="check">✔</td>
      </tr>
      <tr>
        <td>TI Exam Tool</td>
        <td class="cross">✘</td>
        <td class="cross">✘</td>
        <td class="check">✔</td>
      </tr>
      <tr>
        <td>Custom Study Time Table</td>
        <td class="cross">✘</td>
        <td class="cross">✘</td>
        <td class="check">✔</td>
      </tr>
    </tbody>
  </table>
    <div className='tution-fee-button'><a class="state_book_button font-Quick font-bold" href="/form">Check Tuition Fees</a></div>
    </div>)
}